module.exports = __webpack_public_path__ + "img/材料力学1_6_7.90d873f5.jpg";